import { render, staticRenderFns } from "./DialogForm.vue?vue&type=template&id=5e97fe93&scoped=true"
import script from "./DialogForm.vue?vue&type=script&lang=js"
export * from "./DialogForm.vue?vue&type=script&lang=js"
import style0 from "./DialogForm.vue?vue&type=style&index=0&id=5e97fe93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e97fe93",
  null
  
)

export default component.exports